<div class="secondary-navbar">
  <div class="navbar-content">
    <div class="logo-section">
      <img src="assets/svg/company-logo.svg" 
           alt="Logo Empresa" 
           class="logo"
           loading="eager"
           decoding="sync" />
    </div>
    
    <div class="company-name">
      {{ nombreOrganizacion || mensajePendiente }}
    </div>
    
    <div class="divider"></div>
    
    <div class="profile-section">
      <span class="profile-label">Perfil:</span>
      <span class="profile-value">{{ nombreRol || mensajePendiente }}</span>
    </div>
  </div>
</div>